import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalDepositFilterProps {}

const ModalDepositFilter = ({}: ModalDepositFilterProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;

  const isOpen = getModal('single.filterDeposit');

  const onClose = () => {
    closeSingleModal('filterDeposit');
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle={'Filtro de Depósitos'}
      height={'calc(100vh - 70px)'}
      width={'550px'}
      alignment="right"
    >
      <Form.Export.Deposit.Filter />
    </Modal>
  );
};

export default ModalDepositFilter;
